import React from 'react'

const Error404 = () => (

	<div className="contenedor">
			<h1>Error 404, Página no encontrada</h1>
	</div>

)

export default Error404